import type {ForwardedRef, ReactElement} from 'react';
import React from 'react';
import {PopupMenuItemIconSize, PopupMenuItemTypeInModal} from '@Components/popup-menu/components/popup-menu-item/popup-menu-item';
import {PopupMenuItem} from '@Components/popup-menu/components';
import type {MystuffPopupItemProps} from './mystuff-popup-item.types';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {AnimatedBorderElement} from '@Components/animated-border-element/animated-border-element';
import {AnimatedBorderElementType} from '@Components/animated-border-element/animated-border-element.types';
import {noop} from '@Utils/general.util';

// codeReviewShahrukhLater: make a MyStuffPopupTooltipItem and also add styling here to support mobile
export const MystuffPopupItem = React.forwardRef(
  (
    {
      text,
      icon,
      href,
      onClick,
      className = '',
      iconClassName = '',
      textClassName = '',
      isDeleteItem = false,
      disabled = false,
      hrefTarget = '_self',
      hasPremiumUpsell = false,
      hasAnimatedBorder = false,
      onAnimationEnd = noop,
      ...props
    }: MystuffPopupItemProps,
    ref: ForwardedRef<HTMLLIElement>
  ): ReactElement<any> => {
    const getPopupItemClasses = (): string => {
      const classes = ['-smaller radius-4 -only-vertical-margin', className, isDeleteItem ? '-danger' : '', hasAnimatedBorder ? '_full-width _unmargin-bottom' : ''];

      return classes.join(' ');
    };
    const getListItemContent = (): ReactElement => {
      return (
        <PopupMenuItem
          ref={ref}
          href={href}
          itemClasses={getPopupItemClasses()}
          text={text}
          iconClasses={`icon ${icon} ${iconClassName}`}
          disabled={disabled}
          {...(typeof onClick === 'function' && {clickHandler: onClick})}
          target={hrefTarget}
          textColorClasses={`content-body ${textClassName}`}
          iconSize={PopupMenuItemIconSize.SMALL}
          horizontalAlignStart
          popupMenuTypeInModal={PopupMenuItemTypeInModal.UNBORDERED_HORIZONTALLY_ALIGNED_START}
          afterHeaderTextContent={hasPremiumUpsell ? <Icon icon="icon-crown" size={IconSize.SIZE_ICON_16} className="ct-premium-primary-icon spacing-m-l-2" /> : null}
          isListItem={!hasAnimatedBorder}
          data-testid={props['data-testid']}
        />
      );
    };

    return hasAnimatedBorder ? (
      <AnimatedBorderElement className="spacing-m-b-2" elementType={AnimatedBorderElementType.LI} onAnimationEnd={onAnimationEnd}>
        {getListItemContent()}
      </AnimatedBorderElement>
    ) : (
      getListItemContent()
    );
  }
);
